import { Bell, BookOpenCheck, Globe, PlayCircle, TrendingUp } from "lucide-react";
import type { CategoryIconStyle } from "../Types/NotificationTypes";

export const categoryIconStyles: { [key: string]: CategoryIconStyle } = {
  "Web Analytics": { Icon: Globe, modifier: "web" },
  "Track Sales Performance": { Icon: TrendingUp, modifier: "sales" },
  "Social Media Connectivity": { Icon: PlayCircle, modifier: "social" },
  Insights: { Icon: BookOpenCheck, modifier: "insights" },
};

export const defaultCategoryIconStyle: CategoryIconStyle = { Icon: Bell, modifier: "default" };

export const getDashboardNameFromCategory = (
  category: string,
  setSelectedMenuItem?: (val: string) => void
): string => {
  let dashboardName = "Geo-Spatial Analytics Dashboard";

  switch (category) {
    case "Insights":
      dashboardName = "Paid Media Dashboard";
      break;
    case "Track Sales Performance":
      dashboardName = "Sales & Product Analytics Dashboard";
      break;
    case "Social Media Connectivity":
      dashboardName = "Organic Media Dashboard";
      break;
    case "Web Analytics":
      dashboardName = "Web Analytics Dashboard";
      break;
  }

  if (setSelectedMenuItem) {
    setSelectedMenuItem(dashboardName);
  }

  return dashboardName;
};
